import React, { useContext, useEffect, useState } from "react";
import { MainNav } from "./MainNav";
import DashboardMenus from "./DashboardMenus";
import AppContext from "../../context/AppContext";
import { useLocation } from "react-router-dom";
import { ORG_CONTEXT_CHANGED_EVENT } from "../../utils/organizationContext";
import { isDesktopApp } from "../../utils/isDesktop";

export const Layout = ({ children }) => {
  const { theme } = useContext(AppContext);
  const location = useLocation();
  const [showNames, setShowNames] = useState(false);
  const [orgContextKey, setOrgContextKey] = useState(0);
  const desktopShell = isDesktopApp();

  useEffect(() => {
    if (!desktopShell) {
      return undefined;
    }
    const onOrgContextChanged = () => setOrgContextKey((value) => value + 1);
    window.addEventListener(ORG_CONTEXT_CHANGED_EVENT, onOrgContextChanged);
    return () => window.removeEventListener(ORG_CONTEXT_CHANGED_EVENT, onOrgContextChanged);
  }, [desktopShell]);

  const isMapTaskPage = location.pathname === "/maptask";
  const isTaskManagePage = location.pathname === "/task-manage";
  const isLight = theme === "light";

  const shellBg =
    theme === "dark"
      ? "dark-mode bg-gray-950"
      : theme === "high-contrast"
        ? "high-contrast bg-[#F0F0F0]"
        : "app-shell-bg";

  const mainSurface =
    theme === "dark"
      ? "dark-mode rounded-2xl border border-gray-800 bg-gray-900/95 shadow-2xl shadow-black/40"
      : theme === "high-contrast"
        ? "high-contrast rounded-2xl border-2 border-black bg-white shadow-md"
        : isLight
          ? "app-main-surface"
          : "";

  const innerSurface =
    theme === "dark"
      ? "dark-mode rounded-2xl bg-gray-900/40"
      : theme === "high-contrast"
        ? "high-contrast"
        : isLight
          ? "rounded-2xl bg-white/90"
          : "";

  return (
    <div
      className={`flex h-screen min-h-0 w-full overflow-hidden ${shellBg} ${
        isTaskManagePage ? "overflow-hidden" : ""
      }`}
    >
      <aside
        className={`relative z-[80] hidden lg:flex shrink-0 flex-col self-stretch overflow-hidden border-e border-slate-100 bg-white transition-[width] duration-300 ease-in-out ${
          showNames ? "w-[260px] px-3 pb-4 pt-5" : "w-[72px] items-center px-2 pb-4 pt-5"
        }`}
      >
        <div className="custom-side-scrollbar flex min-h-0 flex-1 w-full flex-col overflow-hidden">
          <DashboardMenus setShowNames={setShowNames} showNames={showNames} />
        </div>
      </aside>

      <div
        className={`flex min-h-0 min-w-0 flex-1 flex-col ${
          theme === "dark" ? "dark-mode" : theme === "high-contrast" ? "high-contrast" : ""
        }`}
      >
        <MainNav />

        <main
          className={`min-h-0 flex-1 overflow-x-hidden scroll-smooth pe-3 pb-3 pt-0 sm:pe-4 sm:pb-4 ${
            isMapTaskPage ? "!overflow-hidden" : "overflow-y-auto"
          } ${mainSurface}`}
        >
          <div
            key={desktopShell ? orgContextKey : undefined}
            className={`min-h-full ${innerSurface}`}
          >
            {children}
          </div>
        </main>
      </div>
    </div>
  );
};
